import { styled } from '@mui/material/styles';

export const Content = styled('div')(() => ({
  //background: ${props => props.theme.color.background.surface};
}));

export const FooterActions = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: theme.spacing(-1),
  padding: `${theme.spacing(4)} 0`
}));

export const Header = styled('div')(({ theme }) => ({
  background: theme.color.primary.gradient,
  color: theme.color.primary.contrast,
  padding: `${theme.spacing(3)} 0`
}));

export const Title = styled('h1')(() => ({
  margin: 0
}));
